import type React from "react";

import type { InputProps, QuestionType } from "../answers";

import { BooleanInput } from "./boolean";
import { CountryInput } from "./country";
import { DateInput } from "./date";
import { FileInput } from "./file";
import { MultiSelectInput } from "./multiSelect";
import { NumberInput } from "./number";
import { RatingInput } from "./rating";
import { SignatureInput } from "./signature";
import { SingleSelectInput } from "./singleSelect";
import { TextInput } from "./text";

export const QUESTION_INPUTS: { [T in QuestionType]: React.FC<InputProps<T>> } = {
    text: TextInput,
    number: NumberInput,
    date: DateInput,
    boolean: BooleanInput,
    singleSelect: SingleSelectInput,
    multiSelect: MultiSelectInput,
    rating: RatingInput,
    country: CountryInput,
    file: FileInput,
    signature: SignatureInput,
};
